<template>
    <v-dialog
            v-model="isDialogOpen"
            width="600"
            hide-overlay
            transition="dialog-bottom-transition"
    >
        <v-toolbar
                flat
                dark
                class="main--yellow"
        >
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click.native="$emit('close')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card>
            <v-container class="app-container">
                <v-card-title class="justify-center text-center title">
                    <span>{{ $t('writeSellerFeedback') }}</span><span class="pl-2">{{ $t('aboutSeller') }}</span><span class="pl-2"> {{ companyName }}</span></v-card-title>
                <v-divider class="my-2"></v-divider>
                <v-row>
                    <v-col cols="12" class="pt-2 pt-md-12">
                        <v-rating
                                :value="rating"
                                color="orange lighten-2"
                                dense
                                small
                                background-color="orange lighten-2"
                                @input="ratingChange($event, company)"
                        ></v-rating>
                        <v-card-text>{{ $t('feedbackOne') }} {{ $t('aboutSeller') }}:</v-card-text>
                        <v-textarea
                                outlined
                                v-model="messageText"
                                :placeholder="textArea"
                                color="orange lighten-2"
                                filled
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div class="d-flex align-center">
                    <v-btn class="my-4 px-6 main--yellow" depressed dark @click="send">
                        {{ $t('addFeedback') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text class="text--main-yellow" @click.native="$emit('close')">{{$t('cancel')}}</v-btn>
                </div>
            </v-container>
        </v-card>
        <snack-general :snack-data="snackData"></snack-general>
    </v-dialog>
</template>

<script>

    import AppSnack from '../../../general/mixins/AppSnack';
    import DialogRemote from '../../mixins/DialogRemote';
    import CompanyService from '../../../app-front/services/api/CompanyService';
    import SnackGeneral from '../snacks/SnackGeneral';

    export default {
        name: "CompanyFeedbackDialog",
        props:['company', 'companyName'],
        mixins:[DialogRemote, AppSnack],
        components:{SnackGeneral},
        data(){
            return {
                messageText: null,
                textArea: 'Расскажите о качестве работы продавца: ' +
                    '1) скорость ответа на обращение; ' +
                    '2) актуальность цен и наличие товара; ' +
                    '3) обслуживание и др.',
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                },
                rating: null,
            }
        },
        methods: {
            send() {
                const params = {
                    companyId: this.company,
                    content: this.messageText,
                };

                CompanyService.createCompanyFeedback(params)
                    .then(res => {
                        this.snackHandle(this.$t('messageSent'), 'main--black', true);
                        setTimeout(() => {
                            this.$emit('close');
                        }, 3000);
                        this.$emit('feedback-change');
                        /*this.snackData = {
                            isOpen: true,
                            color: 'main--black',
                            text: this.$t('messageSent')
                        };*/
                    })
                    .catch(err => {
                        this.snackHandle(this.$t('changesSavedError'), 'error', true);
                        console.log(err);
                    });
            },
            ratingChange(value, id) {
                const params = {
                    companyId: id,
                    value: value,
                };
                CompanyService.setCompanyRate(params)
                    .then(res => {
                        this.$emit('rating-change');
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        }
    }
</script>

<style scoped>

</style>
